import { useQuery } from "@tanstack/vue-query";
import Template from "@/services/template/template";
import type { AvailableTemplateVariables } from "@/dtos/Template.dto";

const EMPTY: AvailableTemplateVariables = { contact: [], company: [], sender: [] };

export function useTemplateVariables() {
  return useQuery({
    queryKey: ["templateVariables"],
    queryFn: async (): Promise<AvailableTemplateVariables> => {
      const result = await Template.getTemplateVariables();
      if (result.data.status) {
        return result.data.data;
      }
      throw new Error(result.data.msg || "Failed to load template variables");
    },
    placeholderData: EMPTY,
    // This is entity-schema-derived, not user data — it only changes when a
    // column is added/removed from Contact/Company/User, so it's safe to
    // treat as effectively static for the session.
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
